import React, { Component } from "react"; 
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../components/CustomComponent.js";
export default class PaymentHistory extends Component {
  constructor(props) {
        super(props);
        this.state = {
          document_no: "",
          customer_name: "",
          customer_phone: "",
          created_at: "",
          warehouse_name: "",
          user: "",
          transaction_list: [],
          transaction_list_new: [],
          remark: ""
        };
      }
    
      async componentDidMount() {
        loading(false);
            if(params("uid")){
              await this.Get(params("uid"));
              }
        window.print();
      }
        Get = async (uid) => {
          loading(true);
          let result = await GET("admin/stock-activities/list", { uid });
          if(result?.status){
            const item = result.data;
            this.setState({
              document_no: item.document_no,
              customer_name: item.customer?.full_name || "",
              customer_phone: item.customer?.phone || "",
              created_at: item.created_at,
              warehouse_name: item.warehouse?.name || "",
              user: item.user?.full_name || "",
              transaction_list: item.transaction_list || [],
              transaction_list_new: item.transaction_list_new || [],
              remark: item.remark || ""
            });
          }
          loading(false);
        };
      render() {
        const {document_no,
    customer_name,
    customer_phone,
    created_at,
    warehouse_name,
    user,transaction_list,transaction_list_new,remark} = this.state;
        return (
      <div className="mx-auto bg-white p-5 pdf" style={{ width: 1116, height: 1579 }}>
        <h1 className="fw-bold text-center mb-3">ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่</h1>
        <h4 className="fw-bold text-center mb-3">61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่</h4>
        <h5 className="fw-bold text-center mb-3">โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060</h5>
        <h2 className="fw-bold text-center mb-4">ใบเปลี่ยนสินค้า</h2>
        <div className="row mb-3">
                  <div className="col-6"><h5 className="fw-bold mb-3">เลขที่เอกสาร : {document_no}</h5></div>
                  <div className="col-6"><h5 className="fw-bold mb-3">วันที่เอกสาร : {format_date(created_at,"dd mmmm yyyy","th")}</h5></div>
                  <div className="col-6"><h5 className="fw-bold mb-3">ชื่อลูกค้า : {customer_name}</h5></div>
                  <div className="col-6"><h5 className="fw-bold mb-3">เบอร์โทร : {customer_phone}</h5></div>
                  <div className="col-12"><h5 className="fw-bold mb-3">ที่อยู่ : {document_no}</h5></div>
                  <div className="col-6"><h5 className="fw-bold mb-3">คลังสินค้า : {warehouse_name}</h5></div>
                  <div className="col-6"><h5 className="fw-bold mb-3">ผู้ดำเนินการ : {user}</h5></div>
                </div>
        <h4 className="fw-bold mb-4">รายการคืน</h4>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1 wpx-70">ลำดับที่</td>
              <td className="text-start border-1">รหัส/ชื่อสินค้า</td>
              <td className="text-center border-1">Serial Number</td>
              <td className="text-end border-1 text-end">จำนวน</td>
              <td className="text-end border-1 text-end">ราคา/หน่วย</td>
              <td className="text-end border-1 text-end">มูลค่ารวม</td>
            </tr>
          </thead>
          <tbody>
                      {transaction_list.map((item, index)=>(
                        <tr className="border-0">
                          <td className="text-center" style={{border:"0px 1px"}}>{index + 1}</td>
                          <td className="text-start" style={{border:"0px 1px"}}>{item.product_code} {item.product_name}</td>
                          <td className="text-center" style={{border:"0px 1px"}}>{item.serial_number?.toString()}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{item.qty}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{toFixed(item.unit_price)}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{toFixed(Number(item.qty) * Number(item.unit_price))}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="border-0">
                        <td className="fw-bold text-end" style={{border:0,borderTop:"1px solid #000"}} colSpan={5}>รวมเป็นเงิน</td>
                        <td className="text-end border-1">{(()=>{
                          let _total = 0;
                          transaction_list.forEach((item)=>{
                            _total += Number(item.qty) * Number(item.cost_price);
                          });
                          return toFixed(_total);
                        })()}</td>
                      </tr>
                    </tfoot>
        </table>
         <h4 className="fw-bold mb-4">รายการใหม่</h4>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="fw-bold border-0">
              <td className="text-center border-1 wpx-70">ลำดับที่</td>
              <td className="text-start border-1">รหัส/ชื่อสินค้า</td>
              <td className="text-center border-1">Serial Number</td>
              <td className="text-end border-1 text-end">จำนวน</td>
              <td className="text-end border-1 text-end">ราคา/หน่วย</td>
              <td className="text-end border-1 text-end">มูลค่ารวม</td>
            </tr>
          </thead>
          <tbody>
                      {transaction_list_new.map((item, index)=>(
                        <tr className="border-0">
                          <td className="text-center" style={{border:"0px 1px"}}>{index + 1}</td>
                          <td className="text-start" style={{border:"0px 1px"}}>{item.product_code} {item.product_name}</td>
                          <td className="text-center" style={{border:"0px 1px"}}>{item.serial_number?.toString()}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{item.qty}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{toFixed(item.unit_price)}</td>
                          <td className="text-end" style={{border:"0px 1px"}}>{toFixed(Number(item.qty) * Number(item.unit_price))}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="border-0">
                        <td className="fw-bold text-end" style={{border:0,borderTop:"1px solid #000"}} colSpan={5}>รวมเป็นเงิน</td>
                        <td className="text-end border-1">{(()=>{
                          let _total = 0;
                          transaction_list_new.forEach((item)=>{
                            _total += Number(item.qty) * Number(item.unit_price);
                          });
                          return toFixed(_total);
                        })()}</td>
                      </tr>
                    </tfoot>
        </table>
        <h5 className="fw-bold mb-4">หมายเหตุ</h5>
      </div>
    );
  }
}
